export default __webpack_public_path__ + "static/media/icon-people.e3e80477.svg";